import type { SnapshotTaskStatus } from "@/services/api/data-hub/types";

const TERMINAL_STATUSES = new Set(["completed", "failed", "cancelled"]);

function parseUpdatedAt(value: string | undefined): number {
  if (!value) return 0;
  const ts = Date.parse(value);
  return Number.isNaN(ts) ? 0 : ts;
}

/** Merge an incoming task status without regressing progress or replaying stale HTTP snapshots. */
export function mergeTaskStatus(
  prev: SnapshotTaskStatus | undefined,
  incoming: SnapshotTaskStatus,
): SnapshotTaskStatus {
  if (!prev) return incoming;

  const merged: SnapshotTaskStatus = { ...prev, ...incoming };
  const prevTs = parseUpdatedAt(prev.updated_at);
  const incomingTs = parseUpdatedAt(incoming.updated_at);
  const incomingIsStale = prevTs > 0 && incomingTs > 0 && incomingTs < prevTs;

  merged.progress = Math.max(prev.progress ?? 0, incoming.progress ?? 0);

  if (incoming.steps === undefined && prev.steps) {
    merged.steps = prev.steps;
  }

  if (incomingIsStale) {
    if (prev.status_message) merged.status_message = prev.status_message;
    if (TERMINAL_STATUSES.has(prev.status)) {
      merged.status = prev.status;
      merged.error = prev.error;
    }
  }

  return merged;
}
